export default __webpack_public_path__ + "static/media/review_place_img.ee443d22.svg";